// src/pages/TermsPage.tsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/Card';
import { Footer } from '../components/landing/Footer';

const TermsPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-3xl mb-12 flex-grow">
        <div className="mb-8">
          <Button 
            as={Link} 
            to="/" 
            variant="ghost" 
            className="flex items-center"
          >
            <ArrowLeft size={18} className="mr-1" />
            Back to Home
          </Button>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Terms of Service</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-gray max-w-none">
            <p className="text-sm text-gray-500 mb-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">1. Agreement to Terms</h2>
              <p>
                By accessing or using Simplified Trading Journal, you agree to be bound by these Terms of Service and our Privacy Policy.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">2. Description of Service</h2>
              <p>
                Simplified Trading Journal provides a platform for traders to track their trades, analyze performance, and maintain trading journals.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">3. User Accounts</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must provide accurate account information</li>
                <li>You are responsible for maintaining account security</li>
                <li>You must notify us of any security breaches</li>
                <li>We reserve the right to terminate accounts that violate these terms</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">4. Subscription Terms</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Subscription fees are billed in advance</li>
                <li>Cancellations take effect at the end of the current billing period</li>
                <li>No refunds for partial months of service</li>
                <li>We reserve the right to change pricing with notice</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">5. User Content</h2>
              <p>
                You retain ownership of your content but grant us license to use it to provide the service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">6. Prohibited Activities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Violating laws or regulations</li>
                <li>Interfering with service operation</li>
                <li>Unauthorized access attempts</li>
                <li>Sharing account credentials</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">7. Disclaimer of Warranties</h2>
              <p>
                The service is provided "as is" without warranties of any kind.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">8. Contact</h2>
              <p>
                For questions about these terms, contact us at:{' '}
                <span className="text-gray-600">
                  simplifiedtradingjournal@pm.me
                </span>
              </p>
            </section>
          </CardContent>
        </Card>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsPage;